import {
  DatePickerWithLabel,
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { FormWatcher } from "react-forms-state/src";
import { useTranslations } from "translations";

export const PriorTreatmentSection = () => {
  const translations = useTranslations();
  return (
    <Section
      title={
        translations.patientForms.transitionalCareForm.hospitalStay
          .titlePriorStay
      }
    >
      <SectionRow>
        <DatePickerWithLabel
          elementName="prior_treatment_start_date"
          isBold
          label={
            translations.patientForms.transitionalCareForm.hospitalStay
              .intakeDate
          }
          shouldDisableFuture
        />
        <FormWatcher watchPath="prior_treatment_start_date">
          {({ watchedValue }) => {
            return (
              <DatePickerWithLabel
                blockBefore={watchedValue}
                elementName="prior_treatment_end_date"
                isBold
                label={
                  translations.patientForms.transitionalCareForm.hospitalStay
                    .releaseDate
                }
              />
            );
          }}
        </FormWatcher>
        <TextInputWithLabel
          elementName="prior_treatment_hospital_id"
          isBold
          isLarge
          label={translations.patientForms.transitionalCareForm.hospitalStay.id}
        />
      </SectionRow>
    </Section>
  );
};
